import styled from "styled-components";

const StoresContainer = styled.div`
  min-height: calc(100vh - 98px);
  padding-top: 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  table {
    background-color: #fff;

    .store-column {
      width: 20%;
    }
    .responsible-column {
      width: 25%;
    }
    .region-column {
      width: 15%;
    }
    .returns-column {
      width: 15%;
    }
    .sells-column {
      width: 10%;
    }
    .deposit-column {
      width: 10%;
    }
    .status-column {
      width: 10%;
    }
    .actions-column {
      width: 5%;
    }

    .actions-column:not(.header) {
      padding: 0;
    }
  }

  .datepicker {
    cursor: pointer;

    svg {
      color: #fff;
    }

    input {
      cursor: pointer;
      border: 1px solid #2b0c1a;
      border-radius: 4px;
      background-color: #2b0c1a;
      color: #fff;

      &:hover {
        text-decoration: underline;
      }

      &::placeholder {
        color: #2b0c1a;
      }
    }

    &.empty {
      svg {
        color: #2b0c1a;
      }

      input {
        color: #2b0c1a;
        background-color: #fff;
        
      }
    }
  }

  .datepicker-calendar {
    .react-datepicker__header {
      background-color: #2b0c1a;
      * {
        color: #fff;
      }
    }
  }
  .actions-container {
    button {
      align-self: flex-end;
      width: max-content;
      margin-top: 20px;
      padding: 12px 18px;
      border: 1px solid #dcdce3;
      color: #2b0c1a;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      
      &:hover {
        text-decoration: underline;
      }

      &:disabled {
        cursor: not-allowed;
        background-color: #DCDCE3;
        color: #B3B3B3;
        text-decoration: none;
      }
    }

    .save-btn {
      background-color: #f5cb2b;
      font-weight: 700;
      
    }

    .back-btn {
      background-color: #B3B3B3;
    }
  }

  .bubble {
    margin: 10px;
 
    &::after {
      content: '';
      position: absolute;
      bottom: -8px; /* Alinha a ponta com a parte inferior do balão */
      left: 53px;    /* Ajusta a posição da ponta */
      border-width: 10px;
      border-style: solid;
      border-color: #000000 transparent transparent transparent;
    }
  }
`;

const TableWithFiltersContainer = styled.div`
  .filters-table {
    padding: 8px 0;
    display: flex;
    gap: 20px;

    .select-filter {
      min-width: max-content;
      cursor: pointer;
      height: 28px;

      .css-13cymwt-control,
      .css-t3ipsp-control {
        background-color: #DCDCE3;
        height: 28px;
        min-height: 28px;
        cursor: pointer;

        div {
          color: #74788D;
          font-size: 16px;
          line-height: 18px;

          &:hover {
            text-decoration: underline;
          }
        }

        .css-hlgwow {
          height: 28px;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          margin-left: 10px;
        }

        .css-1wy0on6 {
          height: 28px;

          .css-1xc3v61-indicatorContainer:first-child {
            padding: 0;
          }
        }
      }

      .css-t3ipsp-control {
        border-color: #2b0c1a;
        box-shadow: 0 0 0 1px #2b0c1a;
      }

      .an-simple-select__option.an-simple-select__option--is-selected {
        background-color: #2b0c1a;
        color: #fff;
      }
      .an-simple-select__option:hover {
        background-color: #f4c83e;
      }
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .raffle-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
      padding: 2px 32px;
      width: max-content;
      border: 1px solid #DCDCE3;
      background-color: #F5CB2B;
      color: #2B0C1A;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  
  .stats {
    padding-bottom: 10px;

    .refetch {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        color: #3c7dd9;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
  
        svg {
          font-size: 20px;
        }
  
        &:hover {
          text-decoration: underline;
        }
  
        &.is-loading {
          cursor: not-allowed;
  
          svg {
            display: inline-block;
            animation: rotate 1.5s linear infinite;
          }
        }
      }
  }
`;

export { StoresContainer, TableWithFiltersContainer };
